import * as actionType from "./action";

const initialState = {
  filters: {
    brandIds: [],
    subBrandIds: [],
    gtin: "",
    search: "",
    categoryChips: [],
  },
  statusFilter: "",
  extraColumns: [],
  baseProducts: [],
  reloed: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload,
        },
      };

    case actionType.SET_STATUS_FILTER:
      return {
        ...state,
        statusFilter: action.payload,
      };

    case actionType.SET_BASE_PRODUCTS:
      return {
        ...state,
        baseProducts: action.payload,
        reloed: false,
      };

    case actionType.ADD_CATEGORY_CHIP:
      return {
        ...state,
        filters: {
          ...state.filters,
          categoryChips: [...state.filters.categoryChips, action.payload],
        },
      };

    case actionType.REMOVE_CATEGORY_CHIP:
      return {
        ...state,
        filters: {
          ...state.filters,
          categoryChips: state.filters.categoryChips.filter(
            (c) => c.slug !== action.payload,
          ),
        },
      };

    case actionType.UPDATE_CATEGORY_CHIP:
      return {
        ...state,
        filters: {
          ...state.filters,
          categoryChips: state.filters.categoryChips.map((c) =>
            c.slug === action.payload.oldId ? action.payload.newChip : c,
          ),
        },
      };

    case actionType.CLEAR_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
        statusFilter: "",
      };

    case actionType.SET_EXTRA_COLUMNS:
      return {
        ...state,
        extraColumns: action.payload,
      };

    case actionType.RELOAD:
      return {
        ...state,
        reloed: true,
      };

    default:
      return state;
  }
};

export default reducer;
